import { buildAssessmentSevenDayRoutine } from '@repo/assessment';
import type { EnglishIqDailyTargetMinutesType } from '@repo/config';
import type { EnglishIqMessagesType } from '../../english-iq-messages-type';

interface IEnglishIqV2RoutineProps {
  messages: EnglishIqMessagesType['v2']['result'];
  subBand: string;
  target: EnglishIqDailyTargetMinutesType;
}

export function EnglishIqV2Routine({
  messages,
  subBand,
  target,
}: IEnglishIqV2RoutineProps): React.JSX.Element {
  const routine = buildAssessmentSevenDayRoutine({ dailyTargetMinutes: target, subBand });
  return (
    <section className="mt-10">
      <h3 className="text-2xl font-semibold tracking-tight">{messages.routineTitle}</h3>
      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-7">
        {routine.map((day) => (
          <article className="rounded-2xl border border-[#f7edda]/12 bg-black/20 p-4" key={day.day}>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-[#ff9b50]">
              {messages.day.replace('{day}', String(day.day))}
            </p>
            <p className="mt-3 text-sm text-[#f7edda]/75">
              {messages.lessons.replace('{count}', String(day.lessonCount))}
            </p>
            <p className="mt-1 text-sm text-[#f7edda]/75">
              {messages.repetitions.replace('{count}', String(day.repetitionCount))}
            </p>
            {day.skillFocus ? (
              <p className="mt-3 text-xs font-semibold text-[#ffb36b]">
                {messages.skillFocus.replace('{skill}', day.skillFocus)}
              </p>
            ) : null}
            {day.check ? (
              <p className="mt-3 text-xs font-semibold text-[#ffb36b]">{messages.shortCheck}</p>
            ) : null}
          </article>
        ))}
      </div>
    </section>
  );
}
